import { TypeAlert } from '../../interfaces/TypeAlert/typeAlert'
import { TypeAlertAction } from '../actions/typeAlertActions'
import { GET_TYPE_ALERT_EXITO } from '../types/typeAlertActionsTypes'

export interface TypeAlertState {
  typesAlertState: {
    typesAlert?: TypeAlert[]
    error?: string
  }
}

const initialState: TypeAlertState = {
  typesAlertState: { typesAlert: [], error: '' }
}

export const typesAlertReducer = (
  state: TypeAlertState = initialState,
  action: TypeAlertAction
): TypeAlertState => {
  if (action.type === GET_TYPE_ALERT_EXITO) {
    return {
      ...state,
      typesAlertState: {
        typesAlert: action.typesAlert,
        error: action.error
      }
    }
  }
  return state
}
